/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICittaUserSubscribedViewProps } from './citta-user-subscribed';

export default (props: ICittaUserSubscribedViewProps) => {
    return (null);
};